<template>
    <div class="model-body-wrap">
        <slot />
    </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.model-body-wrap {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    flex-grow: 1;
    margin: 0 $sp-5;
    overflow: auto;
}
</style>
